import React from 'react';
import styles from './Modal.module.css';
import { IoMdClose } from "react-icons/io";


const Modal = ({ title, children, isOpen, onClose, onSave }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button className={styles.closeButton} onClick={onClose}><IoMdClose color='black' size={20}/></button>
        </div>
        <div className={styles.modalBody}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
